// Module
var code = "<h3>Lead details</h3> <div class=\"card\"> <div id=\"leadDetailsForm\" class=\"grid pt-4\"></div> </div> <div class=\"flex justify-end items-center\"> <button type=\"button\" id=\"saveLeadDetailsBtn\" class=\"btn mt-8\" onclick=\"thsTab.saveLead()\">Save</button> </div> ";
// Exports
export default code;